import { Tooltip } from '@mui/material';
import { observer } from "mobx-react-lite";
import { ReactNode } from "react";
import { formatNumber } from "../utils/utils";
import styles from './IconWithTooltip.module.css';

function IconWithTooltip({ title, children, count }: IIconWithTooltipProps) {
    return (
        <Tooltip title={title} arrow>
            <div className={styles.container}>
                {children}
                {count !== undefined && <div className={styles.count}>{formatNumber(count)}</div>}
            </div>
        </Tooltip>
    );
}

export default observer(IconWithTooltip);

interface IIconWithTooltipProps {
    title: string;
    children: ReactNode;
    count?: number;
}
